(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super();
      this.select = null;
      this.buttonText = null;
      this.button = null;
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select');
      this.button = this.querySelector('.element-button');
      
      if (this.select && this.button) {
        this.init();
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-text') || this.button.querySelector('[data-button-text]');
      
      // Set initial text
      this.updateButtonText();
      
      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e));
      
      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e));
      
      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText());
      
      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus());
      this.select.addEventListener('blur', () => this.handleBlur());
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault();
      e.stopPropagation();
      
      // Trigger the native select
      this.select.focus();
      this.select.click();
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault();
          this.select.click();
          break;
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break;
        default:
          // Let other keys pass through
          break;
      }
    }

    updateButtonText() {
      if (!this.buttonText) return;
      
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent;
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option';
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused');
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused');
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e));
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e));
        this.select.removeEventListener('change', () => this.updateButtonText());
        this.select.removeEventListener('focus', () => this.handleFocus());
        this.select.removeEventListener('blur', () => this.handleBlur());
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esl-card-consistency"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.eslCardConsistency) return;
  window.eslCardConsistency = true;
  const roots = new Map();
  const rootSelector = '.index #MainContent .featured-collection-section';
  const cardSelector = '.product__thumbnail';
  const fields = ['.product-thumbnail__title', '.jdgm-widget', '.product-thumbnail__price'];

  function attach(root) {
    if (roots.has(root)) return;
    const widths = new Map();
    const managed = new Set();
    let frame = 0;
    let closed = false;
    const reset = () => {
      managed.forEach(element => element.style.removeProperty('min-height'));
      managed.clear();
    };
    const schedule = () => {
      if (!closed && !frame) frame = requestAnimationFrame(align);
    };
    const resize = window.ResizeObserver ? new ResizeObserver(entries => {
      entries.forEach(({ target, contentRect }) => {
        if (widths.get(target) !== contentRect.width) {
          widths.set(target, contentRect.width);
          schedule();
        }
      });
    }) : null;

    function align() {
      frame = 0;
      if (!root.isConnected) { dispose(); return; }
      reset();
      const cards = [...root.querySelectorAll(cardSelector)];
      widths.forEach((_, card) => {
        if (!cards.includes(card)) { resize?.unobserve(card); widths.delete(card); }
      });
      const grids = new Map();
      cards.forEach(card => {
        if (!widths.has(card)) {
          widths.set(card, card.getBoundingClientRect().width);
          resize?.observe(card);
        }
        if (!card.getClientRects().length) return;
        const rect = card.getBoundingClientRect();
        if (!rect.width) return;
        const parent = card.parentElement;
        if (!grids.has(parent)) grids.set(parent, []);
        const rows = grids.get(parent);
        let row = rows.find(item => Math.abs(item.top - rect.top) < 2);
        if (!row) { row = { top: rect.top, cards: [] }; rows.push(row); }
        row.cards.push(card);
      });
      grids.forEach(rows => {
        rows.filter(row => row.cards.length > 1).forEach(row => {
          fields.forEach(selector => {
            const elements = row.cards.map(card => card.querySelector('.thumbnail__caption > .product-thumbnail > ' + selector)).filter(Boolean);
            const height = Math.ceil(Math.max(0, ...elements.map(element => element.getBoundingClientRect().height)));
            if (!height) return;
            elements.forEach(element => { element.style.minHeight = height + 'px'; managed.add(element); });
          });

        });
      });

    }

    const mutations = new MutationObserver(schedule);
    mutations.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    function dispose() {
      closed = true;
      cancelAnimationFrame(frame);
      mutations.disconnect();
      resize?.disconnect();
      window.removeEventListener('resize', schedule);
      reset();
      roots.delete(root);
    }
    roots.set(root, dispose);
    if (!resize) window.addEventListener('resize', schedule);
    document.fonts?.ready.then(schedule);
    schedule();
  }

  function scan() {
    roots.forEach((dispose, root) => { if (!root.isConnected) dispose(); });
    document.querySelectorAll(rootSelector).forEach(attach);
  }
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    roots.forEach((dispose, root) => { if (event.target.contains(root)) dispose(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esl-cart-refinements"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.eslCartFocusInput) return;
  window.eslCartFocusInput = true;

  const root = document.documentElement;
  const pointerClass = 'esl-cart-pointer-input';
  const setPointer = enabled => {
    if (root.classList.contains(pointerClass) !== enabled) {
      root.classList.toggle(pointerClass, enabled);
    }
  };
  const onPointer = event => {
    if (event.isTrusted) setPointer(true);
  };
  const options = { capture: true, passive: true };
  if ('PointerEvent' in window) {
    document.addEventListener('pointerdown', onPointer, options);
  } else {
    document.addEventListener('touchstart', onPointer, options);
    document.addEventListener('mousedown', onPointer, options);
  }
  document.addEventListener('keydown', event => {
    if (event.isTrusted && !['Shift', 'Control', 'Alt', 'Meta'].includes(event.key)) {
      setPointer(false);
    }
  }, options);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esl-collection-alignment"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.eslCollectionAlignment) return;
  window.eslCollectionAlignment = true;
  const roots = new Map();
  const rootSelector = '.esl-aligned-collection';
  const gridSelector = '.collection-feed--feed-view-standard .view-controller > layout-grid, .collection-feed--feed-view-compact .view-controller > layout-grid';
  const fields = ['.product-thumbnail__title', '.jdgm-widget', '.product-thumbnail__price'];

  function attach(root) {
    if (roots.has(root)) return;
    const widths = new Map();
    const managed = new Set();
    let frame = 0;
    let closed = false;
    const reset = () => {
      managed.forEach(element => element.style.removeProperty('min-height'));
      managed.clear();
    };
    const schedule = () => {
      if (!closed && !frame) frame = requestAnimationFrame(align);
    };
    const resize = window.ResizeObserver ? new ResizeObserver(entries => {
      entries.forEach(({ target, contentRect }) => {
        if (widths.get(target) !== contentRect.width) {
          widths.set(target, contentRect.width);
          schedule();
        }
      });
    }) : null;
    function align() {
      frame = 0;
      if (!root.isConnected) { dispose(); return; }
      reset();
      const grids = [...root.querySelectorAll(gridSelector)];
      widths.forEach((_, grid) => {
        if (!grids.includes(grid)) { resize?.unobserve(grid); widths.delete(grid); }
      });
      grids.forEach(grid => {
        if (!widths.has(grid)) {
          widths.set(grid, grid.getBoundingClientRect().width);
          resize?.observe(grid);
        }
        const rows = [];
        [...grid.children].filter(card => card.matches('.product__thumbnail') && card.getClientRects().length).forEach(card => {
          const top = card.getBoundingClientRect().top;
          let row = rows.find(item => Math.abs(item.top - top) < 2);
          if (!row) { row = { top, cards: [] }; rows.push(row); }
          row.cards.push(card);
        });
        rows.filter(row => row.cards.length > 1).forEach(row => {
          fields.forEach(selector => {
            const elements = row.cards.map(card => card.querySelector('.thumbnail__caption > .product-thumbnail > ' + selector)).filter(Boolean);
            const height = Math.ceil(Math.max(0, ...elements.map(element => element.getBoundingClientRect().height)));
            if (!height) return;
            elements.forEach(element => { element.style.minHeight = height + 'px'; managed.add(element); });
          });
        });
      });
    }
    const mutations = new MutationObserver(schedule);
    mutations.observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    function dispose() {
      closed = true;
      cancelAnimationFrame(frame);
      mutations.disconnect();
      resize?.disconnect();
      window.removeEventListener('resize', schedule);
      reset();
      roots.delete(root);
    }
    roots.set(root, dispose);
    if (!resize) window.addEventListener('resize', schedule);
    document.fonts?.ready.then(schedule);
    schedule();
  }
  function scan() {
    roots.forEach((dispose, root) => { if (!root.isConnected) dispose(); });
    document.querySelectorAll(rootSelector).forEach(attach);
  }
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    roots.forEach((dispose, root) => { if (event.target.contains(root)) dispose(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esl-mobile-purchase-bar"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.eslMobilePurchaseBar) return;

  const mobile = window.matchMedia('(max-width: 798px)');
  let active = null;

  function mount() {
    const wrapper = Array.from(document.querySelectorAll('.product-main [data-product-form]'))
      .find(node => !node.closest('.js-quick-shop, .featured-product-section'));
    if (active && active.wrapper === wrapper && wrapper.isConnected) return;
    if (active) active.destroy();
    active = null;
    if (!wrapper) return;

    const bar = wrapper.querySelector('[data-esl-mobile-purchase]');
    const form = wrapper.querySelector('form.shopify-product-form');
    const native = form && form.querySelector('[data-add-to-cart-trigger]');
    if (!bar || !native) return;

    const button = bar.querySelector('[data-esl-mobile-purchase-button]');
    const label = bar.querySelector('[data-esl-mobile-purchase-label]');
    const cleanups = [];
    let frame = 0;
    let pending = false;
    let failed = false;
    let submitted = false;
    let height = 0;
    let destroyed = false;

    const spacer = document.createElement('div');
    spacer.className = 'esl-mobile-purchase-spacer';
    spacer.hidden = true;
    spacer.setAttribute('aria-hidden', 'true');
    document.body.append(bar, spacer);
    const picker = () => form.querySelector('kit-variant-picker');

    function hasMissingOptions() {
      const currentPicker = picker();
      if (!currentPicker) return false;
      if (currentPicker.selectionIncomplete) return true;
      const radioGroups = new Map();
      currentPicker.querySelectorAll('input[type="radio"]').forEach(input => {
        const holder = input.closest('[data-option-name]');
        if (!holder) return;
        const name = holder.dataset.optionName;
        radioGroups.set(name, Boolean(radioGroups.get(name) || input.checked));
      });
      return Array.from(radioGroups.values()).some(selected => !selected)
        || Array.from(currentPicker.querySelectorAll('select[data-option-name]')).some(select => !select.value);
    }

    function selectedVariant() {
      try {
        const blob = form.querySelector('[data-kit-selected-variant]');
        return blob ? JSON.parse(blob.textContent) : JSON.parse(wrapper.dataset.product).variants[0];
      } catch (_) {
        return null;
      }
    }

    function state() {
      const variant = selectedVariant();
      const id = form.querySelector('[name="id"]');
      const matches = Boolean(variant && id && String(variant.id) === id.value);
      const nativeLabel = (native.querySelector('.text') || native).textContent.trim();
      const nativeDisabled = native.disabled || native.classList.contains('disabled');
      if (pending) return { kind: 'pending', disabled: true, label: bar.dataset.loadingLabel };
      if (native.querySelector('.checkmark-active')) {
        return { kind: 'busy', disabled: true, label: bar.dataset.addedLabel };
      }
      if (hasMissingOptions()) {
        return { kind: 'choose', disabled: false, label: bar.dataset.chooseLabel };
      }
      if (failed || !matches || !variant.available) {
        return { kind: 'unavailable', disabled: true, label: nativeLabel };
      }
      return { kind: 'buy', disabled: nativeDisabled, label: nativeLabel };
    }

    function obstructed() {
      const body = document.body;
      if (body.matches('.mobile-menu--opened, .esl-mobile-menu-dialog-open, .fancybox-active, .show-mini-cart')) return true;
      if (document.querySelector('dialog[open], .mobile-search--visible, .theme-ajax-cart.is-visible, [data-ajax-cart-drawer].is-visible, .ajax-cart__overlay.is-visible, .show-mini-cart')) return true;
      return Boolean(document.activeElement && document.activeElement.matches(
        'textarea, [contenteditable="true"], input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]):not([type="hidden"])'));
    }

    function focusAndScroll(target) {
      if (!target) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ block: 'center', behavior: reduced ? 'auto' : 'smooth' });
      if (!target.matches('button, input, select, textarea, a[href], [tabindex]')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }

    function chooseOptions() {
      focusAndScroll(picker() || native);
      schedule();
    }

    function setVisible(visible) {
      bar.hidden = !visible;
      spacer.hidden = !visible;
      if (document.body.classList.contains('esl-mobile-purchase-active') !== visible) {
        document.body.classList.toggle('esl-mobile-purchase-active', visible);
      }
      const nextHeight = visible ? Math.ceil(bar.getBoundingClientRect().height) : 0;
      if (nextHeight !== height) {
        height = nextHeight;
        document.body.style.setProperty('--esl-mobile-purchase-height', `${height}px`);
      }
    }

    function sync() {
      frame = 0;
      if (destroyed || !wrapper.isConnected) return;
      const current = state();
      if (label.textContent !== current.label) label.textContent = current.label;
      button.disabled = current.disabled;
      const busy = current.kind === 'pending' || current.kind === 'busy';
      if (button.getAttribute('aria-busy') !== String(busy)) button.setAttribute('aria-busy', String(busy));
      const rect = native.getBoundingClientRect();
      setVisible(mobile.matches && rect.height > 0 && rect.bottom <= 0 && !obstructed());

      if (submitted) {
        const error = form.querySelector('.cart-warning__message, .recipient-form__error-message');
        if (error && error.textContent.trim() && error.getClientRects().length) {
          submitted = false;
          focusAndScroll(error);
        } else if (!native.disabled && !native.classList.contains('disabled') && !native.querySelector('.checkmark-active')) {
          submitted = false;
        }
      }
    }

    function schedule() {
      if (!frame && !destroyed) frame = window.requestAnimationFrame(sync);
    }

    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      cleanups.push(() => target.removeEventListener(type, handler, options));
    }
    listen(form, 'change', schedule);
    listen(form, 'kit:variant-picker:change', () => { pending = true; failed = false; button.disabled = true; schedule(); });
    listen(form, 'kit:variant-picker:after-change', event => {
      if (event.detail && event.detail.productChanged) return;
      pending = false;
      failed = false;
      schedule();
    });
    listen(form, 'kit:variant-picker:error', () => { pending = false; failed = true; schedule(); });
    listen(wrapper, 'variant-change', schedule);

    listen(button, 'click', () => {
      if (!mobile.matches || obstructed()) return;
      const current = state();
      if (current.disabled) return;
      if (current.kind === 'choose') return chooseOptions();
      if (current.kind !== 'buy') return;
      if (!form.checkValidity()) {
        focusAndScroll(form.querySelector(':invalid'));
        form.reportValidity();
        return;
      }
      submitted = true;
      native.click();
      schedule();
    });

    listen(window, 'scroll', schedule, { passive: true });
    listen(window, 'resize', schedule, { passive: true });
    listen(window, 'pageshow', schedule);
    listen(document, 'focusin', schedule);
    listen(document, 'focusout', schedule);
    if (window.visualViewport) listen(window.visualViewport, 'resize', schedule, { passive: true });
    if (mobile.addEventListener) listen(mobile, 'change', schedule);

    const observer = new MutationObserver(schedule);
    observer.observe(wrapper, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class', 'data-variant-id'] });
    const overlayObserver = new MutationObserver(records => {
      if (records.some(record => record.target !== bar && !bar.contains(record.target))) schedule();
    });
    overlayObserver.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'open'] });
    const resizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;
    if (resizeObserver) { resizeObserver.observe(native); resizeObserver.observe(bar); }

    active = {
      wrapper,
      destroy() {
        destroyed = true;
        if (frame) window.cancelAnimationFrame(frame);
        cleanups.forEach(cleanup => cleanup());
        observer.disconnect();
        overlayObserver.disconnect();
        if (resizeObserver) resizeObserver.disconnect();
        setVisible(false);
        spacer.remove();
        wrapper.append(bar);
      },
    };
    schedule();
  }

  window.eslMobilePurchaseBar = { mount };
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', event => {
    if (active && event.target.contains(active.wrapper)) {
      active.destroy();
      active = null;
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["esl-navigation-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    let dispose = () => {};

    const initializeSearchScroll = () => {
      dispose();
      dispose = () => {};

      const header = document.querySelector('#mobile-header.esl-mobile-header');
      const row = header && header.querySelector('.esl-mobile-search-row');
      if (!row) return;

      const controller = new AbortController();
      const options = { signal: controller.signal };
      const hiddenClass = 'esl-search-row-hidden';
      const originalAriaHidden = row.getAttribute('aria-hidden');
      const originalInert = row.hasAttribute('inert');
      const root = document.documentElement;
      let frame = 0;
      let direction = 0;
      let distance = 0;
      let viewportWidth = window.innerWidth;

      // Ignore elastic overscroll so returning from an iOS bounce is not a
      // deliberate change of direction.
      const scrollPosition = () => Math.max(0, Math.min(
        window.scrollY,
        Math.max(0, Math.max(root.scrollHeight, document.body.scrollHeight) - window.innerHeight)
      ));
      let previousY = scrollPosition();

      const setHidden = hidden => {
        if (header.classList.contains(hiddenClass) === hidden) return;
        header.classList.toggle(hiddenClass, hidden);
        row.toggleAttribute('inert', hidden || originalInert);
        if (hidden) row.setAttribute('aria-hidden', 'true');
        else if (originalAriaHidden === null) row.removeAttribute('aria-hidden');
        else row.setAttribute('aria-hidden', originalAriaHidden);
      };

      const reset = reveal => {
        previousY = scrollPosition();
        direction = 0;
        distance = 0;
        if (reveal) setHidden(false);
      };

      const isSuspended = () => (
        document.body.classList.contains('mobile-menu--opened') ||
        document.body.classList.contains('esl-mobile-menu-dialog-open') ||
        document.body.style.position === 'fixed' ||
        root.classList.contains('scroll-locked') ||
        Boolean(document.querySelector(
          '.mobile-search--visible, .theme-ajax-cart.is-visible, .show-mini-cart, .ajax-cart__overlay.is-visible'
        ))
      );
      let suspended = isSuspended();

      const syncSuspension = () => {
        const next = isSuspended();
        if (next !== suspended) {
          suspended = next;
          reset(true);
        }
      };

      const update = () => {
        frame = 0;
        syncSuspension();
        const y = scrollPosition();
        const headerStyle = window.getComputedStyle(header);
        const mobileSticky = window.innerWidth <= 1024 &&
          header.getBoundingClientRect().width > 0 &&
          headerStyle.visibility !== 'hidden' && headerStyle.position === 'fixed';

        if (!mobileSticky || suspended || y <= 80 || row.contains(document.activeElement)) {
          reset(true);
          return;
        }

        const delta = y - previousY;
        previousY = y;
        if (!delta) return;

        const nextDirection = Math.sign(delta);
        if (nextDirection !== direction) {
          direction = nextDirection;
          distance = 0;
        }
        distance += Math.abs(delta);
        if (distance >= 16) {
          setHidden(direction > 0);
          distance = 0;
        }
      };

      const schedule = () => {
        if (!frame) frame = window.requestAnimationFrame(update);
      };
      window.addEventListener('scroll', schedule, { ...options, passive: true });
      window.addEventListener('resize', () => {
        const widthChanged = viewportWidth !== window.innerWidth;
        viewportWidth = window.innerWidth;
        reset(widthChanged);
        schedule();
      }, options);
      window.addEventListener('pageshow', () => reset(true), options);
      row.addEventListener('focusin', () => reset(true), options);

      // Watch lock transitions without observing the product grid or all DOM
      // changes. Keep direction tracking paused while a drawer owns scrolling.
      const observer = new MutationObserver(() => {
        syncSuspension();
        schedule();
      });
      const watch = element => observer.observe(element, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });
      [root, document.body, header].forEach(watch);
      document.querySelectorAll('.mobile-search, .theme-ajax-cart, .ajax-cart__overlay, .header-cart').forEach(watch);

      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(header)) dispose();
      }, options);

      dispose = () => {
        controller.abort();
        observer.disconnect();
        if (frame) window.cancelAnimationFrame(frame);
        setHidden(false);
      };
      reset(true);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeSearchScroll, { once: true });
    } else initializeSearchScroll();
    document.addEventListener('shopify:section:load', initializeSearchScroll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-grid', LayoutGrid);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachShadowRoots(this);
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return;
      }
      
      element.querySelectorAll("template[shadowrootmode]").forEach(template => {
        const mode = template.getAttribute("shadowrootmode");
        const shadowRoot = template.parentNode.attachShadow({ mode });

        shadowRoot.appendChild(template.content);
        template.remove();
        this.attachShadowRoots(shadowRoot);
      });
    }
  }

  customElements.define('layout-stack', LayoutStack);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["list.hot-reload"] && !Shopify.designMode) return;
  try {
    class ListHotReload extends HTMLElement {
    FORM_CHANGE_DEBOUNCE_DELAY = 800;
    CHANGE_TRIGGER_SELECTOR = '[data-change-trigger]';
    PAGINATION_SELECTOR = '[data-pagination-part-url]';
    URL_TO_REMOVE_SELECTOR = '[data-url-to-remove]';
    FEED_VIEW_SELECTOR = '[data-feed-view]';
    PRICE_MIN_PARAM_NAME = 'filter.v.price.gte';
    PRICE_MAX_PARAM_NAME = 'filter.v.price.lte';
    PRICE_RANGE_MIN_SELECTOR = `[name="${this.PRICE_MIN_PARAM_NAME}"]`;
    PRICE_RANGE_MAX_SELECTOR = `[name="${this.PRICE_MAX_PARAM_NAME}"]`;
    CHANGE_TRIGGER_TYPES = [
      'form',
      'form_filter',
      'form_select',
      'form_price_range_min',
      'form_price_range_max',
      'sort_select'
    ];

    constructor() {
      super();
      this.formChangeDebounce = null;
      this.cachedSections = [];
      this.abortController = null;
      this.fetchAbortController = null;
    }

    connectedCallback() {
      this.abortController = new AbortController();
      this.id = this.getAttribute('id');
      this.sectionId = this.getAttribute('section-id');
      this.contextUrl = this.getAttribute('context-url');
      this.contextType = this.getAttribute('context-type');
      this.feedView = this.getAttribute('feed-view');

      if (!this.id || !this.contextUrl) {
        console.error('List hot reload: id or contextUrl is not set');
        return;
      }

      this.addEventListener('change', this.handleChange.bind(this), { signal: this.abortController.signal });
      this.addEventListener('list:price-range:slider-change', this.handleFormChange.bind(this), { signal: this.abortController.signal });
      this.addEventListener('click', this.handleClick.bind(this), { signal: this.abortController.signal });
      this.addEventListener('submit', this.handleSubmit.bind(this), { signal: this.abortController.signal });
      window.addEventListener('popstate', this.handlePopstate.bind(this), { signal: this.abortController.signal });

      this.initThemeEditorSupport();
    }

    disconnectedCallback() {
      clearTimeout(this.formChangeDebounce);
      this.fetchAbortController?.abort();
      this.abortController?.abort();
    }

    handleChange(event) {
      const changeTrigger = event.target.dataset.changeTrigger;

      if (!changeTrigger || !this.CHANGE_TRIGGER_TYPES.includes(changeTrigger)) {
        return;
      }

      switch (changeTrigger) {
        case 'sort_select':
          this.updateSortFromSelect(event.target);
          break;
        default:
          this.handleFormChange(event);
      }
    }

    handleFormChange(event) {
      const form = event.target.closest('form');

      if (!form) return;

      clearTimeout(this.formChangeDebounce);
      this.formChangeDebounce = setTimeout(() => {
        this.submitForm(form);
      }, this.FORM_CHANGE_DEBOUNCE_DELAY);
    }

    handleSubmit(event) {
      if (event.target.matches('[data-change-trigger="form"]')) {
        event.preventDefault();
        this.submitForm(event.target);
      }
    }

    handleClick(event) {
      const urlToRemoveBtn = event.target.closest(this.URL_TO_REMOVE_SELECTOR);
      const viewBtn = event.target.closest(this.FEED_VIEW_SELECTOR);
      const paginationBtn = event.target.closest(this.PAGINATION_SELECTOR);

      if (urlToRemoveBtn) {
        const removalUrl = new URL(urlToRemoveBtn.dataset.urlToRemove, window.location.href);
        if (this.contextType === 'collection' && removalUrl.pathname !== window.location.pathname) {
          return;
        }
        event.preventDefault();
        this.renderPage(urlToRemoveBtn.dataset.urlToRemove);
      } else if (viewBtn && viewBtn.dataset.feedView !== this.feedView) {
        event.preventDefault();
        this.updateFeedView(viewBtn.dataset.feedView);
      } else if (paginationBtn) {
        event.preventDefault();
        this.renderPage(paginationBtn.dataset.paginationPartUrl);
      }
    }

    handlePopstate(event) {
      this.renderPage(window.location.href, false);
    }

    updateSortFromSelect(select) {
      const currentParams = new URLSearchParams(window.location.search);
      const value = select.selectedOptions[0].value;

      // Filter out page param
      const filteredParams = Array.from(currentParams).filter(([key]) => {
        return key !== 'page';
      });
      const newParams = new URLSearchParams(filteredParams);

      newParams.set('sort_by', value);
      const paramsString = newParams.toString();
      const url = `${this.contextUrl}${this.contextUrl.includes('?') ? '&' : '?'}${paramsString}`;
      this.renderPage(url);
    }

    submitForm(form) {
      if (!form) return;
      const formData = new FormData(form);
      let newParams = new URLSearchParams(formData);

      // Remove price range params if they are the same as the default price range
      newParams = this.removeDefaultPriceRangeParams(form, newParams);

      // Fetch the page with the new params
      const paramsString = newParams.toString();
      const url = `${this.contextUrl}${this.contextUrl.includes('?') ? '&' : '?'}${paramsString}`;
      this.renderPage(url);
    }

    removeDefaultPriceRangeParams(form, params) {
      const gteInput = form.querySelector(this.PRICE_RANGE_MIN_SELECTOR);
      const lteInput = form.querySelector(this.PRICE_RANGE_MAX_SELECTOR);

      if (!gteInput || !lteInput) return params;

      const priceRangeMin = parseInt(gteInput.getAttribute('min'), 10);
      const priceRangeMax = parseInt(lteInput.getAttribute('max'), 10);
      const gteValue = parseInt(params.get(this.PRICE_MIN_PARAM_NAME), 10);
      const lteValue = parseInt(params.get(this.PRICE_MAX_PARAM_NAME), 10);

      if (gteValue === priceRangeMin && lteValue === priceRangeMax) {
        params.delete(this.PRICE_MIN_PARAM_NAME);
        params.delete(this.PRICE_MAX_PARAM_NAME);
      }

      return params;
    }

    updateFeedView(feedView) {
      this.updateAttribute('feed_view', feedView).then(() => {
        const url = new URL(window.location.href);

        this.feedView = feedView;
        url.searchParams.delete('page');
        this.renderPage(url.toString());
      }).catch((error) => {
        console.error('Failed to update feed view:', error);
        throw error;
      });
    }

    updateAttribute(key, value) {
      this.resetFetchAbortController();
      
      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            [key]: value,
          },
        }),
        signal: this.fetchAbortController.signal,
      }).then((response) => {
          if (!response.ok) throw response;
          return response.json();
      }).catch((error) => {
        if (error.name === 'AbortError') throw error;
        console.error('Failed to update cart attribute:', error);
        throw error;
      });
    }

    renderPage(url, updateURLHash = true) {
      const fullUrl = new URL(url, window.location.origin).toString();

      this.showLoadingState();
      this.scrollToTop();

      return this.renderSectionFromCache(fullUrl).catch(() => {
        return this.renderSectionFromFetch(fullUrl);
      }).then(() => {
        if (updateURLHash) this.updateURLHash(fullUrl);

        // Dispatch custom event for other components to react
        this.dispatchEvent(
          new CustomEvent('list:hot-reload:updated', {
            bubbles: true,
            detail: { context: this.contextType },
          })
        );

        this.hideLoadingState();
      }).catch((error) => {
        if (error.name === 'AbortError') return;
        console.error('Failed to render page:', fullUrl, error);
        this.hideLoadingState();
        throw error;
      });
    }

    scrollToTop() {
      if (this.getBoundingClientRect().y >= 0) return;
      this.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    updateURLHash(url) {
      const currentUrl = new URL(window.location);
      const newUrl = new URL(url, window.location.origin);

      if (currentUrl.pathname !== newUrl.pathname || currentUrl.search !== newUrl.search) {
        window.history.pushState({}, '', newUrl.toString());
      }
    }

    renderSectionFromCache(url) {
      const cachedSection = this.cachedSections.find((cachedSection) => {
        return cachedSection.url === url && cachedSection.feedView === this.feedView;
      });
      if (!cachedSection) return Promise.reject();

      this.renderSection(cachedSection.html);
      return Promise.resolve(cachedSection.url);
    }

    renderSectionFromFetch(url) {
      return this.fetchPage(url).then((sectionHtml) => {
        this.renderSection(sectionHtml);
      });
    }

    renderSection(sectionHtml, section) {
      const html = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const newContent = html.getElementById(this.id);

      this.contextUrl = newContent.getAttribute('context-url');
      this.setAttribute('context-url', this.contextUrl);
      this.textContent = "";

      // Range insertion to preserve declarative shadow DOM
      const range = document.createRange();
      range.selectNodeContents(this);
      range.collapse(true);
      Array.from(newContent.childNodes).forEach(node => {
        range.insertNode(node);
        range.setStartAfter(node);
      });
    }

    fetchPage(url) {
      const sectionUrl = new URL(url, window.location.origin);
      const cacheUrl = sectionUrl.toString();

      // Add section id to the url
      sectionUrl.searchParams.set('sections', this.sectionId);

      this.resetFetchAbortController();

      return fetch(sectionUrl.toString(), {
        signal: this.fetchAbortController.signal,
      }).then((response) => {
        if (!response.ok) throw response;
        return response.json();
      }).then((sectionsData) => {
        const sectionHtml = sectionsData[this.sectionId];
        this.cachedSections.push({ 
          url: cacheUrl,
          html: sectionHtml,
          feedView: this.feedView
        });
        return sectionHtml;
      }).catch((error) => {
        if (error.name === 'AbortError') throw error;
        console.error('Failed to fetch page:', error);
        throw error;
      });
    }

    resetFetchAbortController() {
      this.fetchAbortController?.abort();
      this.fetchAbortController = new AbortController();
    }

    showLoadingState() {
      this.setAttribute('loading', '');
    }

    hideLoadingState() {
      this.removeAttribute('loading');
    }

    initThemeEditorSupport() {
      if (!window.Shopify?.designMode) return;

      // Clear feed_view cart attribute when section is re-rendered in theme editor
      document.addEventListener('shopify:section:load', (e) => {
        if (e.detail?.sectionId !== this.sectionId) return;
        this.updateAttribute('feed_view', '');
      });
    }
  }

  customElements.define('list-hot-reload', ListHotReload);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    class OverlayDrawer extends HTMLElement {
    constructor() {
      super();
      
      
      
      // Store arrow functions to ensure same reference for add/remove
    }

    connectedCallback() {
      this.closeButton = null;
      this.triggers = null;
      this.previouslyFocused = document.activeElement;
      this.trapFocusHandlers = {};
      this.abortController = new AbortController();
      this.closeButton = this.querySelector('[data-drawer-close-button]');
      this.triggers = document.querySelectorAll(
        `[data-open-drawer="${this.id}"]`
      );

      const signal = this.abortController.signal;
      
      // TODO: replace with dialog element
      // this.moveToBody();

      this.closeButton.addEventListener('click', () => this.close(), { signal });
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open();
        }, { signal });
      });
      document.addEventListener('keydown', (event) => this.handleKeydown(event), { signal });
      this.addEventListener('click', (event) => this.handleOverlayClick(event), { signal });
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    open() {
      this.previouslyFocused = document.activeElement;
      
      this.setAttribute('open', 'true');
      this.removeAttribute('inert');
      this.trapFocus(this);
    }
    
    close() {
      this.setAttribute('open', 'false');
      this.setAttribute('inert', '');
      this.removeTrapFocus(this.previouslyFocused);
    }

    moveToBody() {
      if (this.parentNode === document.body) return;
      
      // Store the original parent and next sibling for potential restoration
      this.originalParent = this.parentNode;
      this.originalNextSibling = this.nextSibling;
      
      // Move the element to the body
      document.body.appendChild(this);
    }

    handleOverlayClick(event) {
      if (event.target === this) this.close();
    }

    handleKeydown(event) {
      if (event.key === 'Escape' && this.getAttribute('open') === 'true') {
        this.close();
      }
    }

    removeTrapFocus(elementToFocus = null) {
      if (this.trapFocusAbortController) {
        this.trapFocusAbortController.abort();
        this.trapFocusAbortController = null;
      }

      if (elementToFocus) {
        try {
          elementToFocus.focus({ preventScroll: true })
        } catch (e) {
          elementToFocus.focus()
        }
      }
    }

    forceFocus(element, options = {}) {
      let savedTabIndex = element.tabIndex

      element.tabIndex = -1
      element.dataset.tabIndex = savedTabIndex
      element.focus()
      if (typeof options.className !== 'undefined') {
        element.classList.add(options.className)
      }
      element.addEventListener('blur', callback)

      function callback(event) {
        event.target.removeEventListener(event.type, callback)

        element.tabIndex = savedTabIndex
        delete element.dataset.tabIndex
        if (typeof options.className !== 'undefined') {
          element.classList.remove(options.className)
        }
      }
    }

    focusable(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      )
    }

    trapFocus(container, options = {}) {
      let elements = this.focusable(container)
      let elementToFocus = options.elementToFocus || container
      let first = elements[0]
      let last = elements[elements.length - 1]

      this.removeTrapFocus()

      // Create new AbortController for focus trap events
      this.trapFocusAbortController = new AbortController();
      const signal = this.trapFocusAbortController.signal;

      this.trapFocusHandlers.focusin = function (event) {
        if (container !== event.target && !container.contains(event.target)) {
          this.forceFocus(first || container, options)
        }

        if (event.target !== container && event.target !== last && event.target !== first) return
        document.addEventListener('keydown', this.trapFocusHandlers.keydown, { signal })
      }.bind(this)

      this.trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', this.trapFocusHandlers.keydown)
      }.bind(this)

      this.trapFocusHandlers.keydown = function (event) {
        if (event.keyCode !== 9) return // If not TAB key

        // On the last focusable element and tab forward, focus the first element.
          if (event.target === last && !event.shiftKey) {
        event.preventDefault()
        this.forceFocus(first || container, options)
      }

        //  On the first focusable element and tab backward, focus the last element.
          if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault()
        this.forceFocus(last || container, options)
      }
      }.bind(this)

      document.addEventListener('focusout', this.trapFocusHandlers.focusout, { signal })
      document.addEventListener('focusin', this.trapFocusHandlers.focusin, { signal })

      this.forceFocus(elementToFocus, options)
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer);
  } catch(e) { console.error(e); }
})();

})();
